/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConsultationBaseService } from '../consultation-base-service';
import { ConsultationApiConfiguration } from '../consultation-api-configuration';
import { ConsultationStrictHttpResponse } from '../consultation-strict-http-response';

import { EncounterDetailModel } from '../models/encounter-detail-model';
import { encounterFhirIdGet } from '../fn/encounter/encounter-fhir-id-get';
import { EncounterFhirIdGet$Params } from '../fn/encounter/encounter-fhir-id-get';
import { EncounterModel } from '../models/encounter-model';
import { encounterPatientEncountersPatientFhirIdGet } from '../fn/encounter/encounter-patient-encounters-patient-fhir-id-get';
import { EncounterPatientEncountersPatientFhirIdGet$Params } from '../fn/encounter/encounter-patient-encounters-patient-fhir-id-get';
import { encounterPost } from '../fn/encounter/encounter-post';
import { EncounterPost$Params } from '../fn/encounter/encounter-post';
import { encounterPractitionerEncountersPractitionerFhirIdGet } from '../fn/encounter/encounter-practitioner-encounters-practitioner-fhir-id-get';
import { EncounterPractitionerEncountersPractitionerFhirIdGet$Params } from '../fn/encounter/encounter-practitioner-encounters-practitioner-fhir-id-get';
import { encounterUpdateStatusPost } from '../fn/encounter/encounter-update-status-post';
import { EncounterUpdateStatusPost$Params } from '../fn/encounter/encounter-update-status-post';

@Injectable({ providedIn: 'root' })
export class ConsultationEncounterService extends ConsultationBaseService {
  constructor(config: ConsultationApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `encounterPost()` */
  static readonly EncounterPostPath = '/Encounter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterPost$Response(params?: EncounterPost$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<string>> {
    return encounterPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterPost(params?: EncounterPost$Params, context?: HttpContext): Observable<string> {
    return this.encounterPost$Response(params, context).pipe(
      map((r: ConsultationStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `encounterUpdateStatusPost()` */
  static readonly EncounterUpdateStatusPostPath = '/Encounter/UpdateStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterUpdateStatusPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterUpdateStatusPost$Response(params?: EncounterUpdateStatusPost$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<string>> {
    return encounterUpdateStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterUpdateStatusPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  encounterUpdateStatusPost(params?: EncounterUpdateStatusPost$Params, context?: HttpContext): Observable<string> {
    return this.encounterUpdateStatusPost$Response(params, context).pipe(
      map((r: ConsultationStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `encounterFhirIdGet()` */
  static readonly EncounterFhirIdGetPath = '/Encounter/{fhirId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterFhirIdGet$Response(params: EncounterFhirIdGet$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<EncounterDetailModel>> {
    return encounterFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterFhirIdGet(params: EncounterFhirIdGet$Params, context?: HttpContext): Observable<EncounterDetailModel> {
    return this.encounterFhirIdGet$Response(params, context).pipe(
      map((r: ConsultationStrictHttpResponse<EncounterDetailModel>): EncounterDetailModel => r.body)
    );
  }

  /** Path part for operation `encounterPractitionerEncountersPractitionerFhirIdGet()` */
  static readonly EncounterPractitionerEncountersPractitionerFhirIdGetPath = '/Encounter/PractitionerEncounters/{practitionerFhirId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterPractitionerEncountersPractitionerFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterPractitionerEncountersPractitionerFhirIdGet$Response(params: EncounterPractitionerEncountersPractitionerFhirIdGet$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<Array<EncounterModel>>> {
    return encounterPractitionerEncountersPractitionerFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterPractitionerEncountersPractitionerFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterPractitionerEncountersPractitionerFhirIdGet(params: EncounterPractitionerEncountersPractitionerFhirIdGet$Params, context?: HttpContext): Observable<Array<EncounterModel>> {
    return this.encounterPractitionerEncountersPractitionerFhirIdGet$Response(params, context).pipe(
      map((r: ConsultationStrictHttpResponse<Array<EncounterModel>>): Array<EncounterModel> => r.body)
    );
  }

  /** Path part for operation `encounterPatientEncountersPatientFhirIdGet()` */
  static readonly EncounterPatientEncountersPatientFhirIdGetPath = '/Encounter/PatientEncounters/{patientFhirId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encounterPatientEncountersPatientFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterPatientEncountersPatientFhirIdGet$Response(params: EncounterPatientEncountersPatientFhirIdGet$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<Array<EncounterModel>>> {
    return encounterPatientEncountersPatientFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encounterPatientEncountersPatientFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  encounterPatientEncountersPatientFhirIdGet(params: EncounterPatientEncountersPatientFhirIdGet$Params, context?: HttpContext): Observable<Array<EncounterModel>> {
    return this.encounterPatientEncountersPatientFhirIdGet$Response(params, context).pipe(
      map((r: ConsultationStrictHttpResponse<Array<EncounterModel>>): Array<EncounterModel> => r.body)
    );
  }

}
